import { render, staticRenderFns } from "./marketingPlanDetail.vue?vue&type=template&id=39330f92&scoped=true"
import script from "./marketingPlanDetail.vue?vue&type=script&lang=js"
export * from "./marketingPlanDetail.vue?vue&type=script&lang=js"
import style0 from "./marketingPlanDetail.vue?vue&type=style&index=0&id=39330f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39330f92",
  null
  
)

export default component.exports